import { showErrorToast } from "src/components/AlertToastify/AlertToastify";
import { PaginatedChatHistoryResponse } from "src/components/ChatBot/chatHistoryUtils";

// Envía el audio WAV al backend como multipart/form-data
// y devuelve un Response con un stream SSE (audio_chunk / transcript_chunk / turn_end).
export const chatBot = async (accessAuthToken: string, audioBlob: Blob): Promise<Response> => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_URL}/chatbot/functions/live_chat`;

    const formData = new FormData();
    // Nombre del campo: "audio" (lo leeremos en el backend con FileInterceptor)
    formData.append("audio", audioBlob, "user_audio.wav");

    const response = await fetch(url, {
      method: "POST",
      headers: {
        // No seteamos Content-Type manualmente; el navegador añade el boundary correcto.
        Authorization: `Bearer ${accessAuthToken}`,
      },
      body: formData,
      credentials: "include",
    });

    if (!response.ok) {
      const errorText = await response.text().catch(() => "Request failed");
      console.error("chatBot streaming error response:", errorText);
      throw new Error("Request failed");
    }

    return response;
  } catch (error) {
    showErrorToast("Something went wrong when starting chatbot");
    throw error;
  }
};

export type GetChatHistoryOptions = {
  limit?: number;
  before?: string;
};

export const getChatHistory = async (
  accessAuthToken: string,
  platform: string,
  leagueId: string,
  authId: string,
  options?: GetChatHistoryOptions,
): Promise<PaginatedChatHistoryResponse> => {
  try {
    const encodedPlatform = encodeURIComponent(platform);
    const encodedLeagueId = encodeURIComponent(leagueId);
    const encodedAuthId = encodeURIComponent(authId);
    const params = new URLSearchParams();
    if (options?.limit !== undefined) {
      params.set("limit", String(options.limit));
    }
    if (options?.before) {
      params.set("before", options.before);
    }
    const query = params.toString();
    const url = `${process.env.REACT_APP_BACKEND_URL}/chatbot/history/${encodedPlatform}/${encodedLeagueId}/${encodedAuthId}${query ? `?${query}` : ""}`;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessAuthToken}`,
      },
      credentials: "include",
    });

    if (!response.ok) {
      const errorText = await response.text().catch(() => "Request failed");
      console.error("getChatHistory error response:", errorText);
      throw new Error("Request failed");
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching chat history:", error);
    // Don't show error toast for history, it's not critical
    return { history: [], hasMore: false };
  }
};
